import Banner from "../../components/banner/Banner"
import Events from "../../components/events/Events";
import { useState } from "react";
import RequestGeo from "../../components/requestGeo/RequestGeo"
import "./geoPage.scss"

const GeoPage = () => {
  const [refresh, setRefresh] = useState(false);
  const forceRefresh = () => {
    console.log('force refresh');
    setRefresh(!refresh);
  }
  return (
    <div className="geoPage">
    <Banner title="GeoLocations"/>
    <RequestGeo forceRefresh={forceRefresh}/>
    <Events filter='GEO' refresh={refresh}/>
    {/* <GeoTable /> */}
    </div>
  )
}

export default GeoPage